import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointUp,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { Fragment } from 'react'
import FilterSection from 'src/components/FilterSection/FilterSection'
import NavAwayBox, { NavAwayProps } from 'src/components/NavAwayBox/NavAwayBox'
import TableEmptyState, {
  TableEmptyStateDesigns,
} from 'src/components/TableEmptyState/TableEmptyState'
import TransactionsListMedium from 'src/components/TransactionsListMedium/TransactionsListMedium'
import TransactionsListSmall from 'src/components/TransactionsListSmall/TransactionsListSmall'
import { TransactionListModel } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface TransactionsOverviewBoxProps {
  className?: string
  transactions: TransactionListModel[]
  transactionsLoading: boolean
  transactionsComplete: boolean
  title: React.ReactNode
  navAway?: NavAwayProps
}

const TransactionsOverviewBox: React.FC<TransactionsOverviewBoxProps> = (
  props,
): React.ReactElement => {
  const isEmptyAndComplete =
    props.transactions.length === 0 && props.transactionsComplete

  return (
    <NavAwayBox
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
      `}
      navAway={props.navAway}
      loading={props.transactionsLoading}
    >
      <FilterSection
        topLeftContent={
          <span
            css={css`
              ${getFontCss(
                20,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )}
            `}
          >
            {props.title}
          </span>
        }
      />
      {!isEmptyAndComplete && (
        <Fragment>
          <div
            css={css`
              ${getBreakpointDown(breakpointSizes.XSM)(css`
                display: none;
              `)}
            `}
          >
            <TransactionsListMedium transactions={props.transactions} />
          </div>
          <div
            css={css`
              ${getBreakpointUp(breakpointSizes.SM)(css`
                display: none;
              `)}
            `}
          >
            <TransactionsListSmall transactions={props.transactions} />
          </div>
        </Fragment>
      )}
      {isEmptyAndComplete && (
        <TableEmptyState
          css={css`
            background-color: ${styleConstants.colors.gray_lightest};
          `}
          design={TableEmptyStateDesigns.RecentTransactions}
        />
      )}
    </NavAwayBox>
  )
}

export default TransactionsOverviewBox
